export default __webpack_public_path__ + "static/ghost_chasing-a46e9910489353cadbc49231bf350ada.svg";